import { useDispatch } from "react-redux";
import {
  nextStep,
  prevStep,
  updateField,
} from "../../../store/reducers/users/usersForm.slice";
import { useForm, Controller } from "react-hook-form";
import CustomDatePicker from "./CustomDatePicker";

const StepPersonal = () => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });

  const onSubmit = (data) => {
    Object.entries(data).forEach(([name, value]) => {
      dispatch(updateField({ name, value }));
    });
    dispatch(nextStep());
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="vstack gap-3">
      <div className="form-floating">
        <input
          className={`form-control ${errors.nombres ? "is-invalid" : ""}`}
          placeholder="Nombres"
          {...register("nombres", {
            required: "El nombre es obligatorio",
            minLength: { value: 2, message: "Mínimo 2 caracteres" },
          })}
        />
        <label>Nombres</label>
        {errors.nombres && (
          <div className="invalid-feedback">{errors.nombres.message}</div>
        )}
      </div>

      <div className="form-floating">
        <input
          className={`form-control ${errors.apellido_paterno ? "is-invalid" : ""}`}
          placeholder="Apellido paterno"
          {...register("apellido_paterno", {
            required: "El apellido paterno es obligatorio",
          })}
        />
        <label>Apellido paterno</label>
        {errors.apellido_paterno && (
          <div className="invalid-feedback">
            {errors.apellido_paterno.message}
          </div>
        )}
      </div>

      <div className="form-floating">
        <input
          className={`form-control ${errors.apellido_materno ? "is-invalid" : ""}`}
          placeholder="Apellido materno"
          {...register("apellido_materno", {
            required: "El apellido materno es obligatorio",
          })}
        />
        <label>Apellido materno</label>
        {errors.apellido_materno && (
          <div className="invalid-feedback">
            {errors.apellido_materno.message}
          </div>
        )}
      </div>

      {/* DatePicker opcional — usa Controller de RHF */}
      <Controller
        name="fecha_nacimiento"
        control={control}
        defaultValue=""
        render={({ field, fieldState }) => (
          <CustomDatePicker
            name={field.name}
            value={field.value}
            onChange={(_name, val) => field.onChange(val)}
            error={fieldState.error}
            label="Fecha de nacimiento (opcional)"
          />
        )}
      />

      <div className="form-floating">
        <select
          className={`form-select ${errors.estado_civil ? "is-invalid" : ""}`}
          defaultValue=""
          {...register("estado_civil", {
            required: "El estado civil es obligatorio",
          })}
        >
          <option value="" disabled>
            Estado civil
          </option>
          <option value="SOLTERO">Soltero/a</option>
          <option value="CASADO">Casado/a</option>
          <option value="DIVORCIADO">Divorciado/a</option>
          <option value="VIUDO">Viudo/a</option>
          <option value="UNION_LIBRE">En unión libre</option>
          <option value="SEPARADO">Separado/a</option>
        </select>
        <label>Estado civil</label>
        {errors.estado_civil && (
          <div className="invalid-feedback">{errors.estado_civil.message}</div>
        )}
      </div>

      <div className="d-flex justify-content-between">
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={() => dispatch(prevStep())}
        >
          Atrás
        </button>
        <button type="submit" className="btn btn-primary" disabled={!isValid}>
          Siguiente
        </button>
      </div>
    </form>
  );
};

export default StepPersonal;
